module.exports = __webpack_public_path__ + "static/media/icon_service_instore.a8872081.svg";